import { Flex } from '@grupoboticario/flora-react';

import { ResponsiveFloraTypography } from 'components';
import { getFormattedPrice, pluralize } from 'helpers';

import Styles from './Campaign.styles';

export const StaticCampaign = () => {
  const challengeData = [
    {
      name: 'Desafio 1',
      amount: 1700,
      multiplier: 1,
    },
    {
      name: 'Desafio 2',
      amount: 30000,
      multiplier: 1.5,
    },
    {
      name: 'Desafio 3',
      amount: 80000,
      multiplier: 2,
    },
    {
      name: 'Desafio 4',
      amount: 120000,
      multiplier: 2.5,
    },
    {
      name: 'Desafio 5',
      amount: 650000,
      multiplier: 3,
    },
  ];

  return (
    <Flex direction='column' gap='$8'>
      <Flex direction='column' gap='$6'>
        <ResponsiveFloraTypography as='h2' fontSize='title' fontWeight='bold'>
          Compre e ganhe prêmios
        </ResponsiveFloraTypography>

        <Flex direction='column' gap='$4'>
          <ResponsiveFloraTypography color='$nonInteractivePredominant'>
            Durante os ciclos 4, 5 e 6, todas as suas compras valem pontos. Mas atenção: você só
            começa a acumular a partir do ciclo que realizou a sua inscrição e quando alcançar o
            Desafio 1!
            <br />
            São 5 desafios que podem até triplicar seus pontos conquistados, e ao final do período,
            seus pontos serão liberados para você resgatar prêmios incríveis no catálogo do
            incentivo, não é demais?
          </ResponsiveFloraTypography>
        </Flex>
      </Flex>

      <Styles.Wrapper>
        <Styles.ChallengesWrapper>
          <ResponsiveFloraTypography fontSize='subtitle' fontWeight='bold'>
            Desafios da campanha
          </ResponsiveFloraTypography>

          <Styles.Challenges size='medium'>
            {challengeData.map((challenge, index) => (
              <Styles.ChallengesCard key={`challenge-card-${index}`}>
                <Flex gap='$1'>
                  <Flex direction='column' gap='$4'>
                    <Flex direction='column'>
                      <ResponsiveFloraTypography
                        fontSize='exceptionsRestricted'
                        color='$nonInteractiveAuxiliar'
                      >
                        {challenge.name}
                      </ResponsiveFloraTypography>

                      <ResponsiveFloraTypography
                        fontSize='bodySmallShort'
                        fontWeight='medium'
                        color='$nonInteractiveAuxiliar'
                      >
                        A partir de {getFormattedPrice(challenge.amount)}
                      </ResponsiveFloraTypography>
                    </Flex>

                    <ResponsiveFloraTypography fontWeight='bold' color='$nonInteractiveAuxiliar'>
                      R$ 1,00 ={' '}
                      {new Intl.NumberFormat('pt', { minimumFractionDigits: 1 }).format(
                        challenge.multiplier
                      )}{' '}
                      {pluralize(challenge.multiplier, 'ponto', `pontos`)}
                    </ResponsiveFloraTypography>
                  </Flex>
                </Flex>
              </Styles.ChallengesCard>
            ))}
          </Styles.Challenges>
        </Styles.ChallengesWrapper>
      </Styles.Wrapper>
    </Flex>
  );
};
